import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonProjectDeploymentOverview, CommonProjectDeploymentTopics } from "../../CommonComponents/CommonProjectDeploymentViews";

export const ProjectDeploymentRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.project().release().deployments.specific,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectDeploymentOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectDeploymentTopics />;
    }
};
